import { Component } from '@angular/core';
import { Erma2Service } from './services/erma2.service';
import { NavigationUtils } from './Utils/navigation.utils';
import { GuiOptionsDto } from './dto/gui-options-dto';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent {
  title = 'erma2-zadosti-forms';
  version: string = "?";

  constructor(
    private erma2Service: Erma2Service,
    private navigationUtils: NavigationUtils
  ) { }

  navigation: string = "";

  ngOnInit() {
    var erConf: GuiOptionsDto;
    this.erma2Service.getOptions()
      .subscribe(Erma2Config => {
        erConf = Erma2Config;
        this.version = Erma2Config.appVersion;
        this.erma2Service.getNavigation(Erma2Config)
          .subscribe((navItems: any) => {
            this.navigation = this.navigationUtils.constructNavigation(erConf, navItems);
            //FIXME: vyřešit bez timeoutu (převzato z KSST, celé bych to zrefaktoroval raději...)
            window.setTimeout(this.toggleInit, 1000, this);
          })
      })
  };


  /**
   * Přidá handler pro rozbalení/sbalení navigační nabídky.
   */
  toggleInit(that) {
    let liExpanded = that.elRef.nativeElement.getElementsByClassName('expanded');
    for (var i = 0; i < liExpanded.length; i++) {
      liExpanded.item(i).getElementsByTagName('span').item(0).addEventListener("click", that.navigationCollapseHandler.bind(that));
    }
  }

  /**
   * Rozbalí/spalí navigační nabídku.
   * @param e
   */
  navigationCollapseHandler(e) {
    let el = e.currentTarget.parentElement.getElementsByClassName('submenu').item(0);
    let disp = el.style.display;
    if (disp == 'none') {
      el.style.display = '';
      el.parentElement.classList.add('expanded');
    }
    else {
      el.style.display = 'none';
      el.parentElement.classList.remove('expanded');
    }
  }
}
